<div class="profile-container">
    <div class="">
      <div class="profile-content">
        <div class="personal-details">
          <h4 class="personal-details-title">Add Material Charge</h4>
          <div [formGroup]="form">
            <div class="row">
              <div class="col-md-12 col-lg-12">
                <div class="form-group">
                  <label>Charge Name <span class="required-field">*</span></label>
                  <input formControlName="chargeName" type="text" class="form-control">
                  <span class="err" *ngIf="form.get('chargeName').invalid && formSubmitted">charge name required</span>
                </div>
              </div>
              <div class="col-md-12 col-lg-12">
                <div class="form-group">
                  <label>Quantity</label>
                  <select class="form-control" formControlName="qty">
                    <option value="" disabled selected hidden>-- select uom --</option>
                    <option *ngFor="let uom of uomData" [value]="uom.uomName">{{uom.uomName}}</option>
                  </select>
                  <span class="err" *ngIf="form.get('qty').invalid && formSubmitted">qty required</span>
                </div>
              </div>
              <div class="col-md-12 col-lg-12">
                <div class="form-group">
                  <label>UOM</label>
                  <input formControlName="uom" type="text" class="form-control">
                  <span class="err" *ngIf="form.get('uom').invalid && formSubmitted">uom required</span>
                </div>
              </div>
              <div class="col-md-12 col-lg-12">
                <div class="form-group">
                  <label>Price</label>
                  <input formControlName="price" type="text" class="form-control">
                  <span class="err" *ngIf="form.get('price').invalid && formSubmitted">price required</span>
                </div>
              </div>
              <div class="col-md-12 col-lg-12">
                <div class="form-group">
                  <label>Description</label>
                  <textarea class="form-control" formControlName="description" name="" id="" cols="30" rows="3"></textarea>
                  <span class="err" *ngIf="form.get('description').invalid && formSubmitted">description required</span>
                </div>
              </div>
              <div class="col-md-12 col-lg-12 submit-b">
                <button class="btn btn-primary" *ngIf="!addButton" (click)="addMaterialCharge()">Submit</button>
              </div>
            </div>
          </div>  
        </div>   
      </div>
    </div>
  </div>